import { useMutation, gql } from '@apollo/client';

import { useAppDispatch } from '../../app/hooks';
import { showErrorSnackbar } from '../snackbar/snackbarSlice';

// Uploads a generated PDF to the shared/ folder of the bucket and resolves to a link to it, or null
// if the upload failed (an error snackbar is shown). `name` is what the stored file is named after
// (the recipient's name), independent of the File's own name. `project` is the project id the
// floorplans belong to.
export const useUploadSharedPdf = () => {
  const dispatch = useAppDispatch();

  const [uploadSharedPdf] = useMutation(UPLOADSHAREDPDF, {
    onError: (err) => {
      dispatch(showErrorSnackbar(err.message));
    },
  });

  return async (file: File, name: string, project: string): Promise<string | null> => {
    const res = await uploadSharedPdf({ variables: { file, name, project } });
    return res.data?.uploadSharedPdf ?? null;
  };
};

const UPLOADSHAREDPDF = gql`
  mutation uploadSharedPdf($file: Upload!, $name: String!, $project: MongoID) {
    uploadSharedPdf(file: $file, name: $name, project: $project)
  }
`;
